// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/auth/utils.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/auth/src/utils.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo cash-sync-app
//     node fleet/fleet.ts check --repo cash-sync-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { InitialSyncUIMeta } from "@fleet/state-machines";

interface SyncStatusDescriptionParams {
  ui: InitialSyncUIMeta;
  isSigningOut: boolean;
  downloadProgress?: {
    downloadedOperations: number;
    totalOperations: number;
  };
}

/**
 * Returns the business description key and params for the current sync state.
 * The actual translation happens in the UI.
 */
export function getInitialSyncStatusDescription(params: SyncStatusDescriptionParams): {
  key: string;
  params?: { downloaded: number; total: number };
} {
  const { ui, isSigningOut, downloadProgress } = params;

  if (isSigningOut) {
    return { key: "signing_out" };
  }

  switch (ui.descriptionKey) {
    case "connecting": {
      return { key: "connecting" };
    }
    case "downloading": {
      if (downloadProgress) {
        const { downloadedOperations: downloaded, totalOperations: total } = downloadProgress;
        return {
          key: downloaded === total ? "applying" : "download_progress",
          params: { downloaded, total },
        };
      }
      return { key: "downloading" };
    }
    case "offline": {
      return { key: "offline" };
    }
    case "stuck": {
      return { key: "stuck" };
    }
    case "syncing":
    case "none": {
      return { key: "none" };
    }
  }

  throw new Error(`Unhandled description key: ${String(ui.descriptionKey)}`);
}

/**
 * Type-safe deep clone for Session object.
 * Avoids structuredClone (DataCloneError in some environments) and JSON.parse (unsafe any).
 */
export const cloneSession = <T extends { user: unknown; session: unknown }>(s: T): T => ({
  ...s,
  user: typeof s.user === "object" && s.user !== null ? { ...s.user } : s.user,
  session: typeof s.session === "object" && s.session !== null ? { ...s.session } : s.session,
});
